import React from 'react';

export default function(size=32, style={}) {
  return (
    <svg width={size} height={size} style={style} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" shapeRendering="crispEdges">
      <path stroke="#fab9b9" d="M13 18h5M12 19h1M18 19h1M11 20h1M19 20h1" />
      <path stroke="#e93434" d="M13 19h5M12 20h3M16 20h3M12 21h3M16 21h3M12 22h3M16 22h3M12 23h7M13 24h2M16 24h2" />
      <path stroke="#f4c6d4" d="M15 20h1M15 21h1M15 22h1M15 24h1" />
      <path stroke="#fa9f9f" d="M11 21h1M19 21h1M11 22h1M19 22h1M11 23h1M19 23h1M11 24h1M19 24h1M12 25h1M18 25h1M13 26h5" />
      <path stroke="#d93c3c" d="M12 24h1M18 24h1M13 25h5" />
    </svg>
  )
}


// WEBPACK FOOTER //
// ./src/battle/svg-getters/CombatantWarningIcon.js